import axios from "axios";
import { AppConstants } from "../config/appConstants";

const Axios = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
  baseURL: AppConstants.axiosBaseUrl,
});

/**
 * there is a hook called useAppAxios
 * hook was created because we need to use redux
 */
export const appAxios = Axios;
